import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import * as api from '../../../api/educentialApi';
import VisaDashboard from './VisaDashboard';
import VisaApplicationForm from './VisaApplicationForm';
import VisaDocumentChecklist from './VisaDocumentChecklist';
import VisaStatusTracker from './VisaStatusTracker';
import VisaInterviewPrep from './VisaInterviewPrep';

const VisaServiceRoutes = () => {
  const [enrolled, setEnrolled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkEnrollment();
  }, []);

  const checkEnrollment = async () => {
    try {
      const status = await api.getServiceStatus('visa');
      setEnrolled(status.enrolled);
      
      if (!status.enrolled) {
        await api.enrollInService('visa');
        setEnrolled(true);
      }
    } catch (err) {
      console.error('Enrollment check failed:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route index element={<VisaDashboard />} />
      <Route path="application/new" element={<VisaApplicationForm />} />
      <Route path="application/:applicationId" element={<VisaApplicationForm />} />
      <Route path="application/:applicationId/documents" element={<VisaDocumentChecklist />} />
      <Route path="application/:applicationId/status" element={<VisaStatusTracker />} />
      <Route path="interview-prep" element={<VisaInterviewPrep />} />
      <Route path="*" element={<Navigate to="/services/visa" replace />} />
    </Routes>
  );
};

export default VisaServiceRoutes;
